<template>
  <b-card
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title>Mails autorisés</b-card-title>
      <b-avatar
        variant="light-primary"
        rounded
      >
        <feather-icon
          icon="MailIcon"
          size="18"
        />
      </b-avatar>
    </b-card-header>

    <b-card-body>
      <div
        v-for="mail in platform.allowedMails"
        :key="mail.uuid"
        class="transaction-item"
      >
        <b-media no-body>
          <b-media-aside>
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="AtSignIcon"
                size="18"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="transaction-title">
              {{ mail.extension }}
            </h6>
          </b-media-body>
        </b-media>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BMediaBody,
  BMedia,
  BMediaAside,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { mapGetters } from 'vuex'

export default {
  name: 'PlatformViewAllowedMails',
  setup() {
    return {
      avatarText,
    }
  },
  components: {
    BCard,
    BAvatar,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
  },
  computed: {
    ...mapGetters({
      platform: 'platforms/platform',
    }),
  },
}
</script>

<style scoped>

</style>
